/**
 * Walkthrough/Onboarding module
 * Handles the initial walkthrough dialog with carousel
 */

import { Carousel, Fancybox } from '@fancyapps/ui'

/**
 * Cookie management utilities
 */
function setCookie(cname, cvalue, exdays) {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

function getCookie(cname) {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

/**
 * Initialize the walkthrough dialog
 * Checks for skip cookie and shows walkthrough if needed
 */
export function initWalkthrough() {
  const walkthroughDialog = document.querySelector('.js-walkthrough-dialog')

  if (!walkthroughDialog) {
    return
  }

  // Check if user has skipped walkthrough
  const skipWalkthroughCookie = getCookie('skipWalkthrough')
  if (parseInt(skipWalkthroughCookie, 10) === 1) {
    return
  }

  const walkthroughCarouselElem = document.querySelector('.js-walkthrough-carousel')
  const walkthroughSkipButton = document.querySelector('.js-walkthrough-skip-button')
  const walkthroughCheckbox = document.querySelector('.js-walkthrough-checkbox')

  if (!walkthroughCarouselElem || !walkthroughSkipButton || !walkthroughCheckbox) {
    return
  }

  let onLastSlide = walkthroughCarouselElem.querySelectorAll('.carousel__slide').length > 1 ? false : true

  // Show Fancybox dialog
  const walkthroughFancybox = Fancybox.show([
    {
      src: walkthroughDialog,
      type: 'inline',
      dragToClose: false,
      click: false, // Action to take when the user clicks on the backdrop
    },
  ])

  // Handle closing - set cookie if needed
  walkthroughFancybox.on('closing', () => {
    if (onLastSlide || walkthroughCheckbox.checked) {
      setCookie('skipWalkthrough', 1, 14)
    }
  })

  // Initialize carousel
  const walkthroughCarousel = new Carousel(walkthroughCarouselElem, {
    Navigation: false,
    infinite: false,
    on: {
      change: (carousel) => {
        // Update button text based on slide position
        if (carousel.page >= carousel.pages.length - 1) {
          walkthroughSkipButton.innerHTML = 'Klaar'
          onLastSlide = true
        } else {
          walkthroughSkipButton.innerHTML = 'Overslaan'
          onLastSlide = false
        }
      },
    },
  })

  // Handle skip button click
  walkthroughSkipButton.addEventListener('click', () => {
    walkthroughFancybox.close()

    if (onLastSlide || walkthroughCheckbox.checked) {
      setCookie('skipWalkthrough', 1, 14)
    }
  })
}

